export const paymentMethodSelector = () => ({
  open: true,
  paymentMethod: 'credit_card',
  showCashOnDelivery: false,
  showUnipockPayments: false,
  shippingMethod: '',
  autoPayment: false,
  orderPaymentMethod: null,
  
  init() {
    const orderPaymentMethod = this.$el.dataset.orderPaymentMethod;
    const autoPayment = this.$el.dataset.autoPayment === 'true';
    const showUnipockPayments = this.$el.dataset.showUnipockPayments === 'true';
    
    this.orderPaymentMethod = orderPaymentMethod;
    this.autoPayment = autoPayment;
    this.showUnipockPayments = showUnipockPayments;
    
    if (orderPaymentMethod && autoPayment) {
      this.paymentMethod = orderPaymentMethod;
      
      this.$nextTick(() => {
        this.handlePayment();
      });
    }
    
    document.addEventListener('shipping-method-changed', (event) => {
      this.handleShippingMethodChange(event.detail);
    });
    
    const shippingMethodSelect = document.querySelector('select[name*="shipping_method"]');
    if (shippingMethodSelect) {
      this.shippingMethod = shippingMethodSelect.value;
      this.handleShippingMethodChange({ method: shippingMethodSelect.value });
    }
  },
  
  handleShippingMethodChange(detail) {
    this.shippingMethod = detail.method;
    this.showCashOnDelivery = detail.method === 'convenience_store';
    
    if (detail.method !== 'convenience_store') {
      if (this.paymentMethod === 'cash_on_delivery') {
        this.paymentMethod = 'credit_card';
      }
    }
  },

  isCreditCard() {            
    return this.paymentMethod === 'credit_card';
  },

  isWechatPay() {
    return this.paymentMethod === 'wechat_pay';
  },

  isAlipay() {
    return this.paymentMethod === 'alipay';
  },

  isUnipockPayment() {
    return this.paymentMethod === 'wechat_pay' || this.paymentMethod === 'alipay';
  },

  getPaymentMethodClass(method) {
    return this.paymentMethod === method ? 'border-blue-500 bg-blue-50' : '';
  },

  handlePayment() {
    if (this.isCreditCard()) {
      const tappayButton = document.querySelector('form[data-env] button[type="button"]');
      if (tappayButton) {
        tappayButton.click();
      }
    } else if (this.isUnipockPayment()) {
      this.$dispatch('unipock-payment-start', { 
        method: this.paymentMethod 
      });
    }
  }
});
